import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 9a3 3 0 0 0 0 6v-6","key":"svg-0"}],["path",{"d":"M6 6h3.5l2.5 -2.5l2.5 2.5h3.5v3.5l2.5 2.5l-2.5 2.5v3.5h-3.5l-2.5 2.5l-2.5 -2.5h-3.5v-3.5l-2.5 -2.5l2.5 -2.5l0 -3.5","key":"svg-1"}]]

const IconBrightnessHalf = createReactComponent('outline', 'brightness-half', 'BrightnessHalf', __iconNode);

export default IconBrightnessHalf;